import {FormControl, FormGroup} from '@angular/forms';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {switchMap} from 'rxjs/internal/operators/switchMap';

import {
    ApiError,
    ApiResponse,
    HttpStatusCodesEnum,
    IndividualsService,
    IndividualInterface,
    IndividualModel,
    IndividualExtendedModel,
} from '@spa/api';

import {Helper, SelectControl} from '../../../../shared/classes';

import {ComplianceAMLRiskSelector, ComplianceRiskControl} from '../../../../../assets/descriptors';
import {ComplianceRiskFormErrorStatesEnum} from '../../enums/error-states';

export class ComplianceRiskForm {
    private individual: IndividualExtendedModel;
    private individualsService: IndividualsService;

    public formGroup: FormGroup;
    public control: SelectControl;

    constructor(
        individual: IndividualExtendedModel,
        individualsService: IndividualsService,
    ) {
        this.control = null;
        this.individual = individual;
        this.individualsService = individualsService;
    }

    initForm(): void {
        this.formGroup = new FormGroup({});

        this.control = ComplianceRiskControl();

        if (this.individual.manualRiskClassification) {
            this.control.value = this.individual.manualRiskClassification;
        }

        this.formGroup.addControl(this.control.name, new FormControl(this.control.value, this.control.validators));
    }

    validateForm(messageFunction: (controlLabel?: string) => { [key: string]: string; }): boolean {
        const controls = this.formGroup.controls;

        if (controls[ComplianceAMLRiskSelector].invalid) {
            this.control.errors = Object
                .keys(controls[ComplianceAMLRiskSelector].errors)
                .map((errorKey: string) => {
                    return messageFunction(this.control.placeholder)[errorKey];
                });

            return false;
        }

        return true;
    }

    createRequest(): Observable<ApiResponse<ApiError[] | boolean>> | null {
        const complianceAMLRiskControlValue = this.formGroup.controls[ComplianceAMLRiskSelector].value as number;

        if (this.individual.manualRiskClassification !== complianceAMLRiskControlValue) {
            return this.individualsService.getById(this.individual.id)
                .pipe(
                    switchMap((getResponse: ApiResponse<ApiError[] | IndividualInterface>) => {
                        if (getResponse.status !== HttpStatusCodesEnum.Ok) {
                            return Helper.errorsHelper().createErrorResponseObservable<IndividualInterface>(
                                getResponse,
                                ComplianceRiskFormErrorStatesEnum.GetIndividualFailed
                            );
                        }

                        const data = getResponse.data as IndividualInterface;
                        const model = new IndividualModel(data);
                        model.forceAlias = false;
                        model.manualRiskClassification = complianceAMLRiskControlValue;

                        return this.individualsService.update(model)
                            .pipe(
                                map((updateResponse: ApiResponse<ApiError[] | null>) => {
                                    if (updateResponse.status !== HttpStatusCodesEnum.Ok) {
                                        return Helper.errorsHelper().createErrorResponse<null>(
                                            updateResponse,
                                            ComplianceRiskFormErrorStatesEnum.UpdateIndividualFailed
                                        );
                                    }

                                    this.individual.manualRiskClassification = complianceAMLRiskControlValue;

                                    return Helper.createSuccessResponse<boolean>(true);
                                })
                            );
                    })
                );
        }

        return null;
    }

}
